import { Outlet } from 'react-router-dom';
import { useBridge } from '@completeanatomy/bridge';
import useModel from '../../hooks/useModel';
import React, { useEffect } from 'react';

export function MainPage() {
  const bridge = useBridge();

  useModel();

  useEffect(() => {
    const notify = (payload: string) => {
      bridge?.emit(payload['name'], payload['object']);
    };

    window.notify = notify;

    return () => {
      delete window.notify;
    };
  }, [bridge]);

  return <Outlet />;
}
